export default __webpack_public_path__ + "resources/icons/d340-c119.png";